module.exports = __webpack_public_path__ + "media/application/images/2018/icon-worth-considering-a3e91436aae5095438e0f2fae731f41e.svg";